import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import { openModal, closeModal } from 'features/utilsSlice';
import useModalOpen from 'hooks/useModalOpen';
import RejectMilestoneNote from './RejectMilestoneNote';
import TransitionDialog from 'components/TransitionDialog';
import styles from 'styles/components/gigs/ReviewDialog.module.scss';

const useStyles = makeStyles(theme => ({
  paper: {
    height: 'fit-content',
    width: '90%',
    marginBottom: 'auto',
    marginTop: 100,
    borderRadius: 10,
  },

  paperFullScreenDialog: {
    [theme.breakpoints.up('md')]: {
      width: '50%',
      margin: '0 auto',
    },

    [theme.breakpoints.up('lg')]: {
      width: '35%',
    },
  },
}));

const RejectMilestoneDialog = () => {
  const open = useModalOpen('Reject');
  const dispatch = useDispatch();
  const classes = useStyles();

  const { milestone, gig } = useSelector(state => state.utils.modalData['Reject']);
  const handleClose = () => dispatch(closeModal('Reject'));

  return (
    <>
      <TransitionDialog
        open={open}
        handleClose={handleClose}
        paperProps={{ className: classes.paper }}
        dialogStyles={classes.paperFullScreenDialog}
        direction="up"
        desktopDirection="up"
        style={styles}
        noCloseIcon
      >
        <div className={styles.rejectContainer}>
          <div className={styles.title}>
            <h3>Before you reject</h3>

            <div className={styles.terms} style={{ marginBottom: 20 }}>
              Please read & accept the{' '}
              <a href="/terms" target="_blank">
                Terms Of Use
              </a>
            </div>
          </div>

          <div className={styles.buttons}>
            <Button
              color="primary"
              onClick={() => dispatch(openModal({ name: 'Reject Note' }))}
              fullWidth
            >
              Still Reject
            </Button>

            <Button onClick={handleClose} variant="contained" color="primary" fullWidth>
              Cancel
            </Button>
          </div>
        </div>
      </TransitionDialog>

      <RejectMilestoneNote milestone={milestone} gig={gig} />
    </>
  );
};

export default RejectMilestoneDialog;
